<template>
	<div class="makc-header">
		<div class="makc-header__content">
			<div class="makc-header__left">
				<a href="https://makclife.ru/" class="makc-header__logo">
					<img src="@/create/assets/icons/logo.svg" alt="logo" class="makc-header__logo-pic">
				</a>
			</div>
			<div class="makc-header__middle">
				<div class="makc-header__nav">
					<div class="makc-header__nav-item">
						<a class="makc-header__nav-link text-tdn" href="#">
							<button 
							class="makc-header__nav-btn button button--makc button--makc-smaller button--makc-transparent button--makc-autowidth">
								Оформить договор
							</button>
						</a>
					</div>
					<div class="makc-header__nav-item">
						<a class="makc-header__nav-link text-tdn" href="https://makclife.ru/">
							<button 
							class="makc-header__nav-btn button button--makc button--makc-smaller button--makc-transparent button--makc-autowidth">
								На главную
							</button>
						</a>						
					</div>
				</div>
			</div>
			<div class="makc-header__right">
				<a class="makc-header__right-link text-tdn" href="https://makclife.ru/profile">
					<button 
					class="makc-header__right-btn button button--makc button--makc-smaller button--makc-unfilled button--makc-autowidth">
						Личный кабинет
					</button>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	// props: {
	// 	show: {
	// 		type: Boolean,
	// 		default: false
	// 	},
	// 	tablet: {
	// 		type: String,
	// 		default: 'half_gray'
	// 	}
	// }
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
